export { default } from './ClickableCard';
export { ClickableCardProps } from './ClickableCard.types';
